/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ x: NonNullable<unknown>, y: NonNullable<unknown> }} Position_Modal_Preview_PositionInputs */

const en_position_modal_preview_position = /** @type {(inputs: Position_Modal_Preview_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Char: ${i?.x}, Line: ${i?.y}`)
};

const fr_position_modal_preview_position = /** @type {(inputs: Position_Modal_Preview_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Car : ${i?.x}, Ligne : ${i?.y}`)
};

const de_position_modal_preview_position = /** @type {(inputs: Position_Modal_Preview_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zeichen: ${i?.x}, Zeile: ${i?.y}`)
};

const it_position_modal_preview_position = /** @type {(inputs: Position_Modal_Preview_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carattere: ${i?.x}, Riga: ${i?.y}`)
};

const ru_position_modal_preview_position = /** @type {(inputs: Position_Modal_Preview_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Символ: ${i?.x}, Строка: ${i?.y}`)
};

const es_position_modal_preview_position = /** @type {(inputs: Position_Modal_Preview_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carácter: ${i?.x}, Línea: ${i?.y}`)
};

const zh_cn2_position_modal_preview_position = /** @type {(inputs: Position_Modal_Preview_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`字符：${i?.x}，行：${i?.y}`)
};

const ja_position_modal_preview_position = /** @type {(inputs: Position_Modal_Preview_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`文字: ${i?.x}、行: ${i?.y}`)
};

const hi_position_modal_preview_position = /** @type {(inputs: Position_Modal_Preview_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अक्षर: ${i?.x}, पंक्ति: ${i?.y}`)
};

const pt_pt2_position_modal_preview_position = /** @type {(inputs: Position_Modal_Preview_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caractere: ${i?.x}, Linha: ${i?.y}`)
};

/**
* | output |
* | --- |
* | "Char: {x}, Line: {y}" |
*
* @param {Position_Modal_Preview_PositionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_preview_position = /** @type {((inputs: Position_Modal_Preview_PositionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_Preview_PositionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_modal_preview_position(inputs)
	if (locale === "de") return de_position_modal_preview_position(inputs)
	if (locale === "it") return it_position_modal_preview_position(inputs)
	if (locale === "ru") return ru_position_modal_preview_position(inputs)
	if (locale === "es") return es_position_modal_preview_position(inputs)
	if (locale === "zh-CN") return zh_cn2_position_modal_preview_position(inputs)
	if (locale === "ja") return ja_position_modal_preview_position(inputs)
	if (locale === "hi") return hi_position_modal_preview_position(inputs)
	if (locale === "pt-PT") return pt_pt2_position_modal_preview_position(inputs)
	return en_position_modal_preview_position(inputs)
});